export function setDashType(type){
  localStorage.setItem('dashboardType', type);
  window.location.replace(document.location.origin);
}

export function getDashType(){
  return localStorage.getItem('dashboardType');
}



// WEBPACK FOOTER //
// ./src/businessLogic/userProfileHelper.js